export default {"src":"/_next/static/media/register-success.f2909216.svg","height":449,"width":523,"blurWidth":0,"blurHeight":0};